import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";
import {
  IDeliveredTickets,
  IDeliveredTicketsQueryParams,
} from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";

export class DeliveredTicketsService {
  public getDeliveredTicketsReport = async (
    deliveredTicketsRequest: IDeliveredTicketsQueryParams
  ) => {
    return axiosClient.get<IApiBaseResponse<IDeliveredTickets>>(
      StubHubRoutesEnum.DELIVERED_TICKETS,
      {
        params: deliveredTicketsRequest,
      }
    );
  };
}
